import React, { Component } from 'react';
import './index.scss';
import CustomBanner from '../../components/CustomBanner';
import PurchaseFooter from '../../components/Footer';
import { ReactComponent as BarCode } from '../../assets/images/bar-code-icon.svg';
import { ReactComponent as FnbVoucherImg } from '../../assets/images/fnb-voucher.svg';
import { ReactComponent as TicketVoucherImg } from '../../assets/images/ticket-voucher.svg';
import { ReactComponent as BlackDeleteIcon } from '../../assets/images/delete-black-icon.svg';
import AlertIcon from '../../assets/images/alert-icon.svg';
import * as API from '../../configuration/apiconfig';
import Loader from '../loader';
import BarCodeModal from '../../components/BarcodeModal';
import { showAlert } from '../../components/showAlert';

class index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      voucherImage: '',
      vouchersScanned: [],
      ticketVocuersData: [],
      fnbvouchersData: [],
      // // // // // addVoucherNumber: "3203303950220529",
      voucherNumber: '',
      barcodeModalSH: false,
      scanBarcodeLoaderMsg: 'Barcode scanning in progress',
      scanBarCodeBtnClick: false,
    };
  }

  componentDidMount = async () => {
    window.winvar = this;
    await this.getVoucherImageData();
    await this.getVouchersData();
  };

  addVoucherData = async () => {
    // // // // // var addvoucherNumber = this.state.addVoucherNumber;
    var voucherNumber = this.state.voucherNumber;
    // // // // // API.callEndpoint("POST", "Bearer", "/order/v2/orders/validate-voucher", {vouchercode: addvoucherNumber})
    const cinemaId = localStorage.getItem('cinemaid');
    console.log('localStorage.getItem(cinemaid)', cinemaId);
    API.callEndpoint('POST', 'Bearer', '/order/v2/orders/validate-voucher', { vouchercode: voucherNumber, cinemaid: cinemaId })
      .then(response => {
        // // // // // var responseData = {...response.data, vouchercode: addvoucherNumber};
        var responseData = { ...response.data, vouchercode: voucherNumber };
        var vouchersScannedList = localStorage.getItem('vouchersScanned');
        var vouchersScannedArr = [];
        vouchersScannedArr = JSON.parse(vouchersScannedList);
        // // // // // const index = vouchersScannedArr.findIndex((v) => v.vouchercode === this.state.addVoucherNumber);
        const getVoucherIndex = vouchersScannedArr.findIndex(v => v.vouchercode === this.state.voucherNumber);
        // // // // // if (index !== -1) {
        if (getVoucherIndex !== -1) {
          this.setState(
            {
              barcodeModalSH: false,
              scanBarcodeLoaderMsg: 'Barcode scanning in progress',
            },
            () => {
              showAlert({
                html: `<p>This voucher has already been added. Please try another one.</p>`,
                iconHtml: `<img src=${AlertIcon}>`,
                showCancelButton: false,
                cancelButtonText: 'CANCEL',
                showConfirmButton: true,
                confirmButtonText: 'OK',
                allowOutsideClick: false,
                allowEscapeKey: false,
                iconClasses: 'borderless',
                popupClasses: 'common-error-alert',
                onConfirm: () => { },
              });
            }
          );
          // // // // // return;
        } else {
          this.setState(
            {
              barcodeModalSH: false,
              scanBarcodeLoaderMsg: 'Barcode scanning in progress',
            },
            () => {
              vouchersScannedArr.push(responseData);
              localStorage.setItem('vouchersScanned', JSON.stringify(vouchersScannedArr));
              this.getVouchersData();
              // // // // // this.setState({loader: false});
            }
          );
        }
      })
      .catch(error => {
        this.setState(
          {
            // // // // // loader: false,
            barcodeModalSH: false,
            scanBarcodeLoaderMsg: 'Barcode scanning in progress',
          },
          () => {
            console.log(error.error);
            showAlert({
              html: `<p>${error.error}</p>`,
              iconHtml: `<img src=${AlertIcon}>`,
              showConfirmButton: true,
              confirmButtonText: 'OK',
              allowOutsideClick: false,
              allowEscapeKey: false,
              iconClasses: 'borderless',
              onConfirm: () => { },
            });
          }
        );
      });
  };

  getVouchersData = async () => {
    var storedVouchers = JSON.parse(localStorage.getItem('vouchersScanned'));
    console.log('storedVouchers', storedVouchers);
    let ticketVocuersData = storedVouchers.filter(item => item.ticketRedemption === true);
    let fnbvouchersData = storedVouchers.filter(item => item.ticketRedemption === false);
    this.setState({
      ticketVocuersData: ticketVocuersData,
      fnbvouchersData: fnbvouchersData,
    });
    console.log('ticketVocuersData', ticketVocuersData);
    console.log('fnbvouchersData', fnbvouchersData);
  };

  removeVoucherData = voucherCodeToRemove => {
    showAlert({
      html: `<p>Are you sure you want to delete this voucher ?</p>`,
      iconHtml: `<img src=${AlertIcon}>`,
      showCancelButton: true,
      cancelButtonText: 'No',
      showConfirmButton: true,
      confirmButtonText: 'Yes',
      allowOutsideClick: false,
      allowEscapeKey: false,
      iconClasses: 'borderless',
      popupClasses: 'common-error-alert',
      reverseButtons: true,
      onConfirm: () => {
        const vouchersScannedList = localStorage.getItem('vouchersScanned');
        const vouchersScannedArr = JSON.parse(vouchersScannedList);
        const updatedVocuherList = vouchersScannedArr.filter(v => v.vouchercode !== voucherCodeToRemove);
        localStorage.setItem('vouchersScanned', JSON.stringify(updatedVocuherList));
        this.setState({ vouchersScanned: updatedVocuherList }, () => {
          this.getVouchersData();
        });
      },
    });
  };

  getVoucherImageData = async () => {
    API.callEndpoint('GET', 'Bearer', '/cms/v2/packs/add-voucher-hero-banner-image')
      .then(response => {
        if (response.data.length) {
          var getImage = response.data[0].packs_items[0].packs_items_images.filter(item => item.code == 'x945y436');
          if (getImage.length) {
            this.setState({ voucherImage: getImage[0].imageurl });
          }
        }
        this.setState({ loader: false });
      })
      .catch(err => {
        this.setState({ loader: false });
        console.log(err.error);
        showAlert({
          html: `<p>${err.error}</p>`,
          iconHtml: `<img src=${AlertIcon}>`,
          showConfirmButton: true,
          confirmButtonText: 'OK',
          allowEscapeKey: false,
          iconClasses: 'borderless',
          onConfirm: () => { },
        });
      });
  };

  yourvoucherBackBtn = () => {
    window.location.href = `/addvouchers`;
  };

  continuetoSeatlayout = async () => {
    // When session expiry in login user > delete order
    if (localStorage.getItem('sessionExpiredRedirectUrl') != null && localStorage.getItem('orderId') != null) {
      this.setState({
        loader: true,
      });
      var orderDetails = JSON.parse(localStorage.getItem('orderId'));
      await API.callEndpoint('DELETE', 'Bearer', `/order/v2/orders/${orderDetails.id}`)
        .then(response => {
          localStorage.removeItem('selectedSeats');
          localStorage.removeItem('orderId');
          localStorage.removeItem('cartData');
          localStorage.removeItem('sessionExpiredRedirectUrl');
          this.setState({ loader: false });
        })
        .catch(err => {
          console.log(err.error, 'delete error');
          this.setState({ loader: false });
        });
    }
    const isFnbFlow = localStorage.getItem('orderType') === 'fnb';
    const cinemaId = localStorage.getItem('cinemaid');
    if (isFnbFlow) {
      window.location.href = `fnb?cinemaid=${cinemaId}`;
    } else {
      var getSessionIdFromLocalstorage = localStorage.getItem('sesstionid');
      window.location.href = `/seatlayout?sessionid=${getSessionIdFromLocalstorage}`;
    }
  };

  showVouchersRender = () => {
    const { ticketVocuersData, fnbvouchersData } = this.state;
    if (ticketVocuersData.length > 0 || fnbvouchersData.length > 0) {
      return (
        <>
          <h4>Your Vouchers</h4>
          {ticketVocuersData.length === 0 ? (
            <></>
          ) : (
            <div className="yourVoucherSec">
              <div>
                <div className="voucherHead">
                  {/* <img src={ticketVoucherImg} alt="ticket Voucher" /> */}
                  <TicketVoucherImg />
                  <h5>Ticket Vouchers</h5>
                </div>
                <ul className="voucherList">
                  {ticketVocuersData.map(ticketVocuer => (
                    <li>
                      <p>
                        {ticketVocuer.name}
                        <span>({ticketVocuer.vouchercode})</span>
                      </p>
                      <a onClick={() => this.removeVoucherData(ticketVocuer.vouchercode)} className="removeText">
                        {/* <img src={blackDeleteIcon} alt="Remove" /> */}
                        <BlackDeleteIcon />
                        Remove
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
          {fnbvouchersData.length === 0 ? (
            <></>
          ) : (
            <div className="yourVoucherSec">
              <div className="voucherHead">
                {/* <img src={fnbVoucherImg} alt="fnb Voucher" /> */}
                <FnbVoucherImg />
                <h5>{window.constant.FNB_TEXT_CONTENT} Vouchers</h5>
              </div>
              <div>
                <ul className="voucherList">
                  {fnbvouchersData.map(fnbvoucher => (
                    <li>
                      <p>
                        {fnbvoucher.name}
                        <span>({fnbvoucher.vouchercode})</span>
                      </p>
                      <a onClick={() => this.removeVoucherData(fnbvoucher.vouchercode)} className="removeText">
                        {/* <img src={blackDeleteIcon} alt="Remove" /> */}
                        <BlackDeleteIcon />
                        Remove
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </>
      );
    } else {
      return (
        <aside className="vouchers-not">
          <p>No vouchers added</p>
        </aside>
      );
    }
  };

  scanBarCodeClick = () => {
    window.callbackObj.callEnableBarcodeScan('voucher', window.constant.VOUCHER_CODE_LENGTH);
    this.setState({
      barcodeModalSH: true,
      scanBarCodeBtnClick: true,
      // // // // // loginErrorMsg: "",
      // // // // // manualBarCodeBtnClick: false,
    });
  };

  GetCardInfo = scanData => {
    if (scanData) {
      this.setState(
        {
          voucherNumber: scanData,
          scanBarcodeLoaderMsg: 'Fetching Voucher Info',
        },
        () => {
          window.callbackObj.callDisableBarcodeScan();
          // // // // // this.checkVoucherNumber();
          this.addVoucherData();
        }
      );
    }
  };

  AbortTransactionResponse = response => {
    // This is dot net function
    console.log(response, 'Swipe card abort response--login page');
  };

  disableSubmitBtn = () => {
    var disabled = true;
    if (this.state.memberCardNumber != '') {
      disabled = false;
    } else {
      disabled = true;
    }
    return disabled;
  };

  closeIconClick = getFlow => {
    // // // // // alert("scan modal code here");
    this.setState(
      {
        barcodeModalSH: false,
        voucherNumber: '',
        scanBarCodeBtnClick: false,
        // // // // // memberCardNumber: "",
        manualBarCodeBtnClick: false,
        keyboardInputClickManually: false,
      },
      () => {
        window.callbackObj.callDisableBarcodeScan();
      }
    );
  };

  render() {
    return (
      <>
        <Loader loader={this.state.loader} />
        <section className="yourvoucher-page">
          <section className="yourvoucher-wrapper">
            <CustomBanner
              voucherTitle={window.constant.VOUCHER_PAGE_TITLE ? window.constant.VOUCHER_PAGE_TITLE : 'Got a Voucher to Redeem?'}
              titleLogo={this.state.voucherImage}
              title={''}
              subtitle={false}
              onBackBtnClick={() => this.yourvoucherBackBtn()}
              renderAsHtml={false}
              rewardsRedeemText="Scan any vouchers you may want to redeem now"
            />
            <section className="content">
              <section className="yourVoucherComponent">
                {this.showVouchersRender()}
                <div className="scan-btn paddingTop">
                  <a
                    // // // // // onClick={this.addVoucherData}
                    className="btn btnPrimary"
                    href="javascript:;"
                    title="CLICK TO SCAN BARCODE"
                    onClick={this.scanBarCodeClick}
                  >
                    {/* <span className="plusIcon">+</span> SCAN &amp; ADD VOUCHER */}
                    <span className="plusIcon">+</span> SCAN {this.state.ticketVocuersData.length > 0 || this.state.fnbvouchersData.length > 0 ? 'ANOTHER VOUCHER' : '& ADD VOUCHER'}
                    {/* <img src={barCode} alt="Bar code" /> */}
                    <BarCode />
                  </a>
                </div>
              </section>
            </section>
          </section>
        </section>
        <BarCodeModal
          parentState={this.state}
          closeIconClick={this.closeIconClick}
          keyBoardOnChange={this.keyBoardOnChange}
          keyBoardOnKeyPress={this.keyBoardOnKeyPress}
          keyBoardHandleShift={this.keyBoardHandleShift}
          clickKeyboardIcon={this.clickKeyboardIcon}
          disableSubmitBtn={this.disableSubmitBtn}
          userLogin={this.userLogin}
          keyBoardIcon={false}
        />
        <PurchaseFooter
          fnbDataForTicketSummary={[]}
          ticketsDataForTicketSummary={[]}
          removeItemFromCart={false}
          incDecItem={false}
          backBtnClick={this.yourvoucherBackBtn}
          nextBtnClick={this.continuetoSeatlayout}
          nextBtnText="Continue"
          nextBtnDisable={false}
        ></PurchaseFooter>
      </>
    );
  }
}

export default index;
